import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogoUpdateService {
    private logoUpdatedSource = new Subject<string | null>();
    logoUpdated$ = this.logoUpdatedSource.asObservable();

    emitLogoUpdated(url: string | null) {
        this.logoUpdatedSource.next(url);
    }

    private distributorChangedSource = new Subject<number>();
    distributorChanged$ = this.distributorChangedSource.asObservable();

    emitDistributorChanged(id: number) {
        this.distributorChangedSource.next(id);
    }

}
